import './admin.scss';
import './plugin-settings/settings';

jQuery(document).ready(function () {
	const $ = jQuery;

	const { ajaxurl } = devnet_pingvid_script_data;

	const updateMarginLabels = (selectedPosition, marginRows) => {
		const nbPosition = selectedPosition.val();

		if (nbPosition) {
			const nbPositions = nbPosition.split('-');
			marginRows.get().forEach((row, i) => {
				const label = $(row).find('th label');
				const updatedLabel = label.find('span');
				const position = nbPositions[i].toUpperCase();
				const marginPositionHTML = `<span class="devnet-text-change">${position}</span>`;

				if (updatedLabel.length) {
					updatedLabel.replaceWith(marginPositionHTML);
				} else {
					label.append(`<span>${position}</span>`);
				}
			});
		}
	};

	const nbPositionField = $('[name="devnet_pingvid_display[position]"]');
	const nbMarginRows = $(
		'#devnet_pingvid_display tr.margin_y, #devnet_pingvid_display tr.margin_x'
	);

	updateMarginLabels(nbPositionField, nbMarginRows);

	$(nbPositionField).on('change', function (e) {
		updateMarginLabels($(this), nbMarginRows);
	});

	async function apiRequest({
		endpoint,
		method = 'GET',
		nonce = '',
		data = null,
	}) {
		const options = {
			method,
			headers: {
				'X-WP-Nonce': nonce,
			},
		};

		if (data) {
			options.headers['Content-Type'] = 'application/json';
			options.body = JSON.stringify(data);
		}

		try {
			const response = await fetch(endpoint, options);
			const result = await response.json();
			return result;
		} catch (error) {
			console.error('API Request failed:', error);
			return { status: 'error', message: 'Request failed' };
		}
	}
});
